export default {"src":"/_next/static/media/img-testicon-category.7462895f.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};